(function () {
  function getSwitchRoot(trigger) {
    const header = trigger.closest(".size-chart__header");
    return header ? header.parentElement : null;
  }

  function setUnitTables(root, unit) {
    if (!root) return;

    root.querySelectorAll(".size-chart__header-item").forEach((item) => {
      const isInch = item.classList.contains("inch");
      const isCm = item.classList.contains("cm");
      item.classList.toggle(
        "toggle--active",
        (unit === "in" && isInch) || (unit === "cm" && isCm)
      );
    });

    root.querySelectorAll(".size-chart_table").forEach((table) => {
      const show =
        (unit === "in" && table.classList.contains("inch")) ||
        (unit === "cm" && table.classList.contains("cm"));

      table.classList.toggle("active", show);
      if (show) {
        table.removeAttribute("hidden");
      } else {
        table.setAttribute("hidden", "");
      }
    });
  }

  function initSwitchRoots() {
    document.querySelectorAll(".size-chart__header").forEach((header) => {
      const root = header.parentElement;
      if (!root || root.dataset.sizeUnitReady === "true") return;

      root.dataset.sizeUnitReady = "true";
      const active = header.querySelector(
        ".size-chart__header-item.toggle--active"
      );
      const unit = active?.classList.contains("cm") ? "cm" : "in";
      setUnitTables(root, unit);
    });
  }

  document.addEventListener("click", (event) => {
    const item = event.target.closest(".size-chart__header-item");
    if (!item) return;
    if (!item.classList.contains("inch") && !item.classList.contains("cm")) {
      return;
    }

    setUnitTables(
      getSwitchRoot(item),
      item.classList.contains("cm") ? "cm" : "in"
    );
  });

  window.toggleSizechartTable = function (val, triggerEl) {
    const root = triggerEl
      ? getSwitchRoot(triggerEl)
      : document.querySelector(".help-sizeguide--chart, .tab-content__panel");
    setUnitTables(root, val === "cm" ? "cm" : "in");
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSwitchRoots);
  } else {
    initSwitchRoots();
  }
})();
